import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ImagesService } from "../../services/images.service";

@Component({
  selector: "app-uploaded-image",
  templateUrl: "./uploaded-image.component.html",
  styleUrls: ["./uploaded-image.component.scss"],
})
export class UploadedImageComponent {
  @Input() imageId: string;
  @Input() showDeleteButton = true;
  @Input() dimensions: { width: string; height: string } = {
    width: "auto",
    height: "auto",
  };
  @Input() previewDimensions: { width: number; height: number } = {
    width: 300,
    height: 300,
  };
  @Output() imageDeleted = new EventEmitter();

  constructor(public imagesService: ImagesService) {}

  onDeleteImageClicked() {
    this.imageDeleted.emit();
  }
  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = "assets/media/common/not-found.png";
  }
}
